import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reinhried',
  templateUrl: './app-reinhried.component.html',
  styleUrls: ['./app-reinhried.component.scss']
})
export class AppReinhriedComponent implements OnInit {
  public myPassword="";
  hide = true;
  hidecode = false;
  constructor() { }

  ngOnInit(): void {
  }


  onPasswordInput() {

    if (this.myPassword=="kastanie8")
    {
      this.hidecode = true;
    }
    else
    {
      this.hidecode=false;
    }


  }

}
